module.exports = __webpack_public_path__ + "assets/img/tsaLogo.df481829.png";